import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";

type PropsStyle = {
  width?: string | number;
  padding?: string | number;
  marginBottom?: string | number;
  textTransform?: string;
  endIcon?: boolean;
};

const useStyles = createUseStyles(() => ({
  buttonRoot: {
    "&.MuiButton-root": {
      width: (props: PropsStyle) => props.width || "100%",
      padding: (props: PropsStyle) => props.padding || "3px 20px",
      marginBottom: (props: PropsStyle) => props.marginBottom || 0,
      textTransform: (props: PropsStyle) => props.textTransform || "none",
      height: "30px",
      borderRadius: "50px",
      margin: "0",
      border: 0,
      color: colors.primary,
      textWrap: "nowrap",

      /*
       * ETAT DESACTIVE.
       *
       * Il n'y en avait aucun. MUI applique bien `.MuiButton-root.Mui-disabled`,
       * mais les regles de ce fichier ont la meme specificite (0,2,0) et JSS
       * les injecte apres : la couleur du variant l'emportait, et un bouton
       * desactive etait pixel pour pixel identique a un bouton actif.
       *
       * C'est ce qui a fait remonter le bouton "Relancer le collaborateur"
       * comme "ne marche pas" plutot que comme "indisponible" : il avait
       * l'air cliquable, le curseur restait normal, et le clic ne faisait
       * rien. `!important` est necessaire ici pour battre les regles de
       * variant ci-dessous, qui ciblent aussi `&.MuiButton-root`.
       */
      "&.Mui-disabled": {
        opacity: 0.45,
        cursor: "not-allowed",
        pointerEvents: "auto",
        color: `${colors.textSecondary} !important`,
        "& svg": { opacity: 0.7 },
      },

      "& > div": {
        marginLeft: "10px",
        marginRight: (props: PropsStyle) =>
          props.endIcon ? "15px" : undefined,
      },
      "&:hover": {
        backgroundColor: colors.surface,
        border: `1px solid ${colors.borderLight}`,
      },
    },
  },
  variantDefault: {
    "&.MuiButton-root": {
      color: colors.BLACK,
      backgroundColor: colors.default,
      "&:hover": {
        backgroundColor: colors.default,
      },
    },
  },
  variantPrimary: {
    "&.MuiButton-root": {
      backgroundColor: colors.primary,
      color: colors.WHITE,
      "&:hover": {
        backgroundColor: colors.primary,
      },
    },
  },
  variantSecondary: {
    "&.MuiButton-root": {
      backgroundColor: colors.secondary,
      color: colors.WHITE,
      "&:hover": {
        backgroundColor: colors.secondary,
      },
    },
  },
  variantTertiary: {
    "&.MuiButton-root": {
      backgroundColor: colors.tertiary,
      color: colors.WHITE,
      "&:hover": {
        backgroundColor: colors.tertiary,
      },
    },
  },
  variantWhite: {
    "&.MuiButton-root": {
      backgroundColor: colors.surface,
      border: `1px solid ${colors.borderLight}`,
      color: colors.primary,
      "&:hover": {
        backgroundColor: colors.surface,
        border: `1px solid ${colors.borderLight}`,
      },
    },
  },
  variantWithIcon: {
    "&.MuiButton-root": {
      backgroundColor: colors.surface,
      border: `1px solid ${colors.borderLight}`,
      color: colors.primary,
      "&:hover": {
        backgroundColor: colors.surface,
        border: `1px solid ${colors.borderLight}`,
      },
    },
  },
}));

export default useStyles;
